import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.FOTO_FOTO_COGNADO;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  INTRODUCTION: 'INTRODUCTION',
  STANDARD: 'STANDARD',
  TAKE_PHOTOS: 'TAKE_PHOTOS',
  COMPLETE_SENTENCE: 'COMPLETE_SENTENCE',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  START_LEVEL: 'START_LEVEL',
  SET_LAST_LEVEL_CLICKED: 'SET_LAST_LEVEL_CLICKED',
  INCREMENT_CORRECT_ITEM_COUNT: 'INCREMENT_CORRECT_ITEM_COUNT',
  MARK_INTRO_AS_SEEN: 'MARK_INTRO_AS_SEEN',
};

export const FILENAME_POSFIX = {
  SPANISH: 'spa',
  ENGLISH: 'en',
  SPANISH_COMPLETE: 'spa_complete',
  ENGLISH_COMPLETE: 'en_complete',
};

export const ATTEMPTS_ALLOWED_PER_ITEM = 1;

export const LEVEL_MASTERY_THRESHOLD = 8;

export const UNDERSCORES = ' _______ ';

export const IN_BETWEEN_ASTERIKS_RGX = /\*(.*?)\*/;

export const ALL_UNDERSCORES_RGX = /(_+)/g;

export const ALL_ASTERIKS_RGX = /(\*+)/g;

export const BUTTON_TYPES = {
  CONTINUE: 'continue',
  TRY_AGAIN: 'try_again',
  START: 'start',
};

export const BUTTON_COLORS = {
  ORANGE: 'orange',
  PURPLE: 'purple',
  INDIGO: 'indigo',
  CORAL: 'coral',
};

export const MAX_PHOTOS = 4;
